import axios from 'axios'
const token = { token: 'super-secret' }

export async function getWeibo(id) {
  let { data } = await axios.get(`/api/mobile/sns/weibo`, {
    params: { ...token, id },
  })
  return data
}

export async function getComment(id, limit = 3) {
  let { data } = await axios(`/api/mobile/sns/commentList`, {
    params: { ...token, limit, id },
  })
  return data
}

export async function getTopic(id) {
  let { data } = await axios(`/api/mobile/sns/topicDetail`, {
    params: { ...token, id },
  })
  return data
}

export async function getWeiboList(id, type = 'TOPIC', limit = 3) {
  let { data } = await axios(`/api/mobile/sns/weiboList`, {
    params: { ...token, type, limit, id },
  })
  return data
}

export async function getArticle(id) {
  let { data } = await axios(`/api/mobile/sns/articleDetail`, {
    params: { ...token, id },
  })
  return data
}

export async function getWeiboCount(id, type = 'ARTICLE') {
  let { data } = await axios(`/api/mobile/sns/weiboCount`, {
    params: { ...token, type, id },
  })
  return data
}
